module.exports = __webpack_public_path__ + "img/static__image.55239f25.png";